import React, {useState} from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View,useWindowDimensions,TouchableOpacity,TextInput } from 'react-native';
export default function App() {
  const myWidth =useWindowDimensions().width;
  const myHeight =useWindowDimensions().height;
  function scaling(min,sizee) {
    return myWidth / (1520 / sizee) < min ? min : myWidth / (1520 / sizee);
};
function formulaWom(sum_beta){
  var val=1-Math.pow(0.94833,Math.pow(Math.E,sum_beta-26.0145))
  val=val*100
  val=Math.round(val)
  return val
}

function formulaMan(sum_beta){
  var val=1-Math.pow(0.88431,Math.pow(Math.E,sum_beta-23.9388))
  val=val*100
  val=Math.round(val)
  return val
}

function sum_beta_man(age,BMI,SBP,SBPStat,smoke,diab){
  const val=(Math.log(age)*3.11296+Math.log(BMI)*0.79277+
  Math.log(SBP)*1.85508*(1-SBPStat)+
  Math.log(SBP)*1.92672*SBPStat+
  smoke*0.70963+diab*0.53160)
  return val
}
function sum_beta_wom(age,BMI,SBP,SBPStat,smoke,diab){
  const val=(Math.log(age)*2.72107+Math.log(BMI)*0.51125+
  Math.log(SBP)*2.81291*(1-SBPStat)+
  Math.log(SBP)*2.88267*SBPStat+
  smoke*0.61868+diab*0.77763);
  return val
}
const [age,setAge]=useState(0)
const [bmi,setbmi]=useState(0.0)
const [sbp,setsbp]=useState(0.0)
const [sbpStat,setsbps]=useState(0)
const [smok,setsmok]=useState(0)
const [dia,setdia]=useState(0)
const [sex,setSex]=useState('')
const[rist,setRist]=useState(0)

  return (
    <View style={[styles.container]}>

      <View style={{width:myWidth,height:scaling(10,200), top:0,paddingBottom:scaling(100,320)}}>
      <Text style={{fontSize:scaling(20,40),color:'#333',position:'absolute',top:scaling(10,20),alignSelf:'center'}}>Katakit Health Risk Assessment</Text>
      <Text style={{fontSize:scaling(10,26),color:'#333',position:'absolute',top:scaling(40,100),alignSelf:'center',textAlign:'center'}}>Cardivascular Risk assessment 
      calculator tailored for the African population</Text>
      <Text style={{fontSize:scaling(10,20),color:'#333',position:'absolute',top:scaling(80,140),alignSelf:'center',textAlign:'center'}}>
Please follow the formatting exactly as in the place holder

      </Text>
      </View>
      <View style={{width:scaling(10,800),height:scaling(10,900)}}>

<View style={{paddingBottom:scaling(30,60)}}>
      <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,40),}}>Age: </Text>
  <TextInput placeholder='e.g. 30' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100)}}
  placeholderTextColor='#A0A0A0' onChangeText={newText=>setAge(Number(newText))}/>
  </View>

  <View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#f0f0f0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,40),}}>Sex: </Text>
  <TextInput placeholder='m or f' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0' onChangeText={newText=>setSex(newText)}/>
</View>

<View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,190),}}>BMI: </Text>
  <TextInput placeholder='e.g. 25.0' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0'
  onChangeText={newText=>setbmi(Number(newText))}/>
</View>

<View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,190),}}>Systolic blood pressure: </Text>
  <TextInput placeholder='e.g. 120' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0'
  onChangeText={newText=>setsbp(Number(newText))}/>
</View>

<View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,190),}}>Diabetes: </Text>
  <TextInput placeholder='yes or no' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0'
  onChangeText={newText=>setdia(newText=='yes'?1:0)}/>
</View>

  <View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,190),}}>Smoking: </Text>
  <TextInput placeholder='yes or no' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0'
  onChangeText={newText=>setsmok(newText=='yes'?1:0)}/>
</View>

<View style={{paddingBottom:scaling(30,60)}}>
  <View style={{marginTop:'#A0A0A0',width:scaling(10,800), alignSelf:'center',
      position:'absolute',height:scaling(10,60)/*borderWidth:scaling(1,5)*/,top:0,borderTopWidth:scaling(1,2)}}>
  </View>
  <Text style={{fontSize:scaling(10,20),top:scaling(10,190),}}>Blood pressure medication: </Text>
  <TextInput placeholder='yes or no' style={{top:scaling(5,8),position:'absolute',
  alignSelf:'flex-end',borderStyle:'solid',borderWidth:scaling(1,2),height:scaling(20,40),width:scaling(50,100),}}
  placeholderTextColor='#A0A0A0'
  onChangeText={newText=>setsbps(newText=='yes'?1:0)}/>
</View>

<Text style={{fontSize:scaling(10,40)}}>Risk Rate: {sex=='m'?formulaMan(sum_beta_man(age,bmi,sbp,sbpStat,smok,dia)):formulaWom(sum_beta_wom(age,bmi,sbp,sbpStat,smok,dia))}%</Text>
</View>
<View style={{marginBottom:scaling(10,40),position:'absolute',bottom:'0%',}}>
<View style={{width:scaling(10,1000),height:scaling(1,2),backgroundColor:'#000',position:'relative',alignSelf:'center',marginBottom:scaling(10,50)}}></View>
<Text style={{fontSize:scaling(10,20),position:'relative',paddingLeft:scaling(10,50),paddingRight:scaling(10,50)}}>This risk calculator is a modified version of the
 Framingham cardiovascular risk calculator
  based on data from the African continent (mDoc).
   We hope to implement this algorithm in the mDoc application
    as part of its offered services to their patients. 
    We advise that this questionaire is offered periodically 
    to monitor the change in their chances of developing cardivascular 
    diseases based on their actual habits. The earlier we know,
     the eariler we act, the earlier we treat.</Text>
     </View>
      <StatusBar style="auto" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex:1,
    backgroundColor: '#f0f0f0',
    alignItems: 'center',
  },
});
